import React from 'react';

import { CircularProgress } from '@mui/material';
import styled from 'styled-components';

const Container = styled.div`
    width: 100vw;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export interface LoadingPros {
    backgroundColor?: string;
    sx?: any;
}

const Loading = (props: LoadingPros) => {
    const { backgroundColor, sx } = props;
    return (
        <Container style={{ ...sx, backgroundColor: backgroundColor || '#fff' }}>
            <CircularProgress />
        </Container>
    );
};

export default Loading;
